import {
    useEffect,
    useState,
} from 'react';

import {Autocomplete,} from '@mantine/core';

import {usePipelineTemplates} from '../hooks/usePipelineTemplates';
import {PipelineTemplate} from '../types';
import {FieldProps} from 'formik';

export const PipelineTemplatesAutocomplete = ({
                                                  field: {
                                                      name,
                                                      value: fieldValue,
                                                  },
                                                  form: {setFieldValue},
                                                  ...rest
                                              }: FieldProps) => {

    const [value, setValue] = useState('');
    const [disabled, setDisabled] = useState(false);

    const {items: records} = usePipelineTemplates();

    const data = records.map((record: PipelineTemplate) => record.name || '');

    useEffect(() => {
        if (records.length === 0) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }

        const found = records.find((item: PipelineTemplate) => item.id === fieldValue);
        if (typeof found !== 'undefined' && Object.prototype.hasOwnProperty.call(found, 'name')) {
            setValue(found.name as string);
        }
    }, [records.length, fieldValue]);

    const handleChange = (value: string) => {
        const found = records.find((item: PipelineTemplate) => item.name === value);

        if (typeof found !== 'undefined') {
            setFieldValue(name, found.id);
        }

        setValue(value);
    };

    return (
        <Autocomplete
            name={name}
            value={value}
            onChange={handleChange}
            data={data}
            disabled={disabled}
            placeholder='Select Pipeline Template'
            {...rest}
        />
    );
};
